import {SmtPublication} from "../../utils/types";
import React, {ReactElement} from "react";
import {Tooltip} from 'antd';
import ComponentFromString from '../../utils/ComponentFromString';
import { Html5Entities } from 'html-entities';
const htmlEntities = new Html5Entities();

interface SmtPublicationTitleProps {
    smtPub: SmtPublication
}

const SmtPublicationTitle = ({smtPub}: SmtPublicationTitleProps) => {
    let title;
    let titleContent = smtPub && smtPub.title;
    let component;
    if (titleContent) {
        // firstly we need to decode some html entities such as decode &amp; to &
        titleContent = htmlEntities.decode(titleContent);

        component = ComponentFromString(titleContent)
    }
    // if (smtPub && smtPub.smt_url) {
    //     title = (
    //         <Tooltip overlayClassName="sub-heading-font" title='summit article page' placement="topLeft">
    //             <a href={smtPub.gs_url}
    //                target="_blank"
    //                rel="noopener noreferrer"
    //                className="sfu-red-link"
    //             >{titleContent?component:'[No title available]'}</a>
    //         </Tooltip>
    //     )
    // } else if (titleContent) {
    //     title = component;
    // } else {
    //     title = ''
    // }
    if (titleContent) {
        title = component;
    } else {
        title = ''
    }
    return title as ReactElement;
};

export default SmtPublicationTitle;